import React from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Badge,
  Text,
  Link,
  Tooltip,
  Icon
} from '@chakra-ui/react';
import { InfoIcon } from '@chakra-ui/icons';

const PolicyResultsTable = ({ policies, type }) => {
  if (!policies || policies.length === 0) {
    return <Text color="gray.500">No {type} found.</Text>;
  }

  return (
    <TableContainer border="1px" borderColor="gray.200" borderRadius="md">
      <Table size="sm" variant="simple">
        <Thead bg="gray.50">
          <Tr>
            <Th width="120px">ID</Th>
            <Th>Title</Th>
            <Th width="150px">Relevance Score</Th>
            <Th>Summary</Th>
          </Tr>
        </Thead>
        <Tbody>
          {policies.map((record) => (
            <Tr key={record.source_id}>
              <Td>
                <Link
                  color="blue.500"
                  href={`https://www.cms.gov/medicare-coverage-database/view/${record.source_type}.aspx?${record.source_type === 'article' ? 'articleId' : 'lcdid'}=${record.source_id.replace(/^[A-Z]+/, '')}`}
                  isExternal
                >
                  {record.source_id}
                </Link>
              </Td>
              <Td>
                <Text fontWeight="bold">{record.title}</Text>
              </Td>
              <Td>
                <Badge colorScheme={record.relevance_score > 50 ? 'green' : 'yellow'} mr={2}>
                  {record.relevance_score}
                </Badge>
                {record.relevance_explanation && (
                  <Tooltip label={record.relevance_explanation} placement="top">
                    <InfoIcon color="blue.500" />
                  </Tooltip>
                )}
              </Td>
              <Td>
                <Text color="gray.600" fontSize="sm">{record.summary}</Text>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default PolicyResultsTable;
